import { render } from "./TextCalculator.vue?vue&type=template&id=1f6ca722"
import script from "./TextCalculator.vue?vue&type=script&lang=js"
export * from "./TextCalculator.vue?vue&type=script&lang=js"

import "./TextCalculator.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script